import { useState, useEffect, useCallback } from 'react';
import '../../utils/responsive.es.js';
import { useIsDestroyed } from '../../hooks/useIsDestroyed/useIsDestroyed.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';

var useImage = function useImage(props) {
  var src = props.src,
      crossOrigin = props.crossOrigin,
      srcSet = props.srcSet,
      sizes = props.sizes,
      onLoad = props.onLoad,
      onError = props.onError;

  var _useState = useState("pending"),
      status = _useState[0],
      setStatus = _useState[1];

  var isDestroyed = useIsDestroyed();
  useEffect(function () {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  var loadImage = useCallback(function () {
    if (!src) return;
    var image = new Image();
    image.src = src;

    if (crossOrigin) {
      image.crossOrigin = crossOrigin;
    }

    if (srcSet) {
      image.srcset = srcSet;
    }

    if (sizes) {
      image.sizes = sizes;
    }

    image.onload = function (event) {
      if (isDestroyed.current) return;
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };

    image.onerror = function (event) {
      if (isDestroyed.current) return;
      setStatus("failed");
      onError == null ? void 0 : onError(event);
    };
  }, [crossOrigin, isDestroyed, onError, onLoad, sizes, src, srcSet]);
  useEnhancedEffect(function () {
    if (status === "loading") {
      loadImage();
    }
  }, [status, loadImage]);
  return {
    isLoaded: status === "loaded",
    isFailed: status === "failed",
    isPending: status === "pending",
    isLoading: status === "loading"
  };
};

export { useImage };